// extracted by mini-css-extract-plugin
export default {"wrap":"EF-z","fullWidth":"FF-z","hideOnDesktop":"GF-z","content":"HF-z","hasOpenedNav":"IF-z","crumbsList":"JF-z","dropdownsWrap":"KF-z"};